import { Alert, Button, Dialog, Heading, Text } from "@idg-web-platform/pulse";
import css from "./approvalBox.module.css";
import { useEffect, useRef, useState } from "preact/hooks";

export function ApprovalBox() {
  let sending = false;

  const dialogSuccessRef = useRef<HTMLDialogElement>(null);
  const dialogFailedRef = useRef<HTMLDialogElement>(null);
  const [dialogState, setDialogState] = useState<"none" | "success" | "failed">("none");

  useEffect(() => {
    if (dialogState === "success") {
      dialogSuccessRef.current?.showModal?.();
    } else {
      dialogSuccessRef.current?.close?.();
    }
  }, [dialogState]);

  useEffect(() => {
    if (dialogState === "failed") {
      dialogFailedRef.current?.showModal?.();
    } else {
      dialogFailedRef.current?.close?.();
    }
  }, [dialogState]);

  useEffect(() => {
    const handleSuccessClose = () => setDialogState("none");
    const handleFailedClose = () => setDialogState("none");
    dialogSuccessRef.current?.addEventListener("close", handleSuccessClose);
    dialogFailedRef.current?.addEventListener("close", handleFailedClose);
    return () => {
      dialogSuccessRef.current?.removeEventListener("close", handleSuccessClose);
      dialogFailedRef.current?.removeEventListener("close", handleFailedClose);
    };
  }, []);

  function sendAgain() {
    if (!sending) {
      sending = true;
      fetch("/api/c/club/send-link-account", { method: "POST" }).then((response) => {
        sending = false;
        if (response.status === 204) {
          setDialogState("success");
        } else {
          console.log(response);
          setDialogState("failed");
        }
      });
    }
  }

  return (
    <>
      <Alert
        type="warning"
        headline="Bestätige deine CLUB-Mitgliedschaft"
        showCloseButton={false}
        description="Wir haben dir eine E-Mail geschickt. Bitte bestätige innerhalb von 24 Stunden deine E-Mail-Adresse, damit wir deinen CLUB mit deinem Online-Konto verknüpfen können."
      >
        <div className={css.alertContent}>Link abgelaufen oder funktioniert nicht?</div>
        <div className={css.alertContent}>
          <Button className={css.link} text="E-Mail erneut anfordern" onClick={sendAgain} />
        </div>
      </Alert>
      <div style={{ display: "contents" }}>
        {dialogState === "success" && (
          <Dialog ref={dialogSuccessRef} role="dialog" onClose={() => setDialogState("none")}>
            <div className={css.dialogHeader}>
              <Heading>Du hast Post!</Heading>
              <Text fontStyle="bold">Bitte prüfe dein E-Mail-Postfach</Text>
            </div>
            <div className={css.dialogContent}>
              <Text>
                Wir haben dir eine E-Mail geschickt, um deine CLUB-Mitgliedschaft zu bestätigen.
              </Text>
              <Text>
                Bitte klicke innerhalb von 24 Stunden auf den Button in der E-Mail, damit wir deinen
                CLUB mit deinem Online-Konto verknüpfen können.
              </Text>
              <Text>Bitte überprüfe auch deinen Spam-Ordner.</Text>
            </div>
          </Dialog>
        )}
      </div>
      <div style={{ display: "contents" }}>
        {dialogState === "failed" && (
          <Dialog ref={dialogFailedRef} role="dialog" onClose={() => setDialogState("none")}>
            <div className={css.dialogHeader}>
              <Heading>Das hat leider nicht geklappt</Heading>
            </div>
            <div className={css.dialogContent}>
              <Text>Bitte versuche es später noch einmal.</Text>
              <Text>
                Wenn das Problem bestehen bleibt, melde dich bitte bei unserem{" "}
                <a href="/c/account/contact?issue=club">Kundenservice</a>.
              </Text>
            </div>
          </Dialog>
        )}
      </div>
    </>
  );
}
